import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[treeElement]'
})
export class TreeElementDirective {
  template = inject<TemplateRef<any>>(TemplateRef);
}
